import ChevronRight from '@assets/icons/chevron-double-right.svg';
import React from 'react';
import { ICON_BUTTON_HIT_SLOP } from '@/components/navigation-header-content';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

export const InboundListExpandButton: React.FC<Props> = ({
  onPress,
  style,
}) => {
  const theme = useTheme();

  return (
    <TouchableOpacity
      hitSlop={ICON_BUTTON_HIT_SLOP}
      onPress={onPress}
      style={[styles.expandIcon, style]}
      testID="expand-inbounds-list-panel"
    >
      <ChevronRight fill={theme.sk.color.icon.tertiary} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  expandIcon: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
